import {CLEAR_ERRORS, SET_ERRORS} from './types'
import {setNewTokenInStorage} from "../helpers/authHelper";

// RETURN ERRORS
export const setErrors = (error, id = null) => {
    const msg = error?.response?.data?.message ?? error.message;
    if (error.response.headers) {
        setNewTokenInStorage(error?.response?.headers);
    }

    return {
        type: SET_ERRORS,
        payload: {
            status: error?.response?.status,
            msg,
            id,
        },
    }
}

// CLEAR ERRORS
export const clearErrors = () => {
    return {
        type: CLEAR_ERRORS
    }
}